module.exports = __webpack_public_path__ + "static/img/step4_1tc@2x.7452dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step4_1tc@2x.jpg
// module id = 541
// module chunks = 0